RegExp.escapeString = (string) => {
  if (!string) return;

  return String(string).replace(/([!$()*+/:=?[\\\]^{|}])/g, '\\$1');
};

export const validateEmail = (email) => {
  // We scape the input to avoid Dos
  const textToReview = RegExp.escapeString(email);
  const emailRegex = /^[^\s@]+@[\w-.]+\.\w{2,}$/;

  return emailRegex.test(textToReview);
};

export const validatePassword = (password) => {
  return password.length > 5;
};

/** Valdate postcode by regex
 *
 * @param {string} postCode - The postcode to validate
 * @returns {boolean}
 */
export const validatePostCode = (postCode) => {
  const codeToReview = RegExp.escapeString(postCode);
  const regex = /^[a-z]{1,2}\d[\da-z]?\s?\d[a-z]{2}$/i;

  return regex.test(codeToReview);
};

export const validateName = (name) => {
  const value = RegExp.escapeString(name);

  return /^([^\d\n!"#$%&()*+,/:;<=>?@[\\\]^_`{|}~£¬]+)$/.test(value);
};

export const validatePhone = (number) => {
  const value = RegExp.escapeString(number);

  return /^\+?(\s*\d){9,20}\s*$/.test(value);
};

export const validateNumber = (number) => {
  const value = RegExp.escapeString(number);

  return /^\d+$/i.test(value);
};

export const validateCharacter = (char) => {
  const value = RegExp.escapeString(char);

  return /^[\da-z-]*$/i.test(value);
};
